// Slick carousel
$(document).ready(function($) {

  $('.slick-carousel').each(function(index, element) {

    var slider = $(this);

    slider.slick({
      //infinite: true, // data-slick
      //autoplay: true, // data-slick
      //fade: true, // data-slick
      //arrows: true, // data-slick
      //dots: true, // data-slick
      prevArrow: $('.slick-carousel-prev')[index],
      nextArrow: $('.slick-carousel-next')[index],
      swipe: true,
      touchThreshold: 1000,
      speed: 600,
      autoplaySpeed: 3000,
      slidesToShow: 1,
      slidesToScroll: 1
    });

  });

});
